var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeymomentsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 10.22 20.4722 8.47991 19.4832 6.99987C18.4943 5.51983 17.0887 4.36628 15.4442 3.68509C13.7996 3.0039 11.99 2.82567 10.2442 3.17294C8.49836 3.5202 6.89472 4.37737 5.63604 5.63604C4.37737 6.89472 3.5202 8.49836 3.17294 10.2442C2.82567 11.99 3.0039 13.7996 3.68509 15.4442C4.36628 17.0887 5.51983 18.4943 6.99987 19.4832C8.47991 20.4722 10.22 21 12 21",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.391H12.391V7",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5578 16.7542C20.6916 16.8274 20.8033 16.9353 20.8811 17.0665C20.9589 17.1977 20.9999 17.3474 20.9999 17.5C20.9999 17.6525 20.9589 17.8022 20.8811 17.9334C20.8033 18.0646 20.6916 18.1725 20.5578 18.2457L19.2864 18.941C19.1406 19.0207 19.0207 19.1406 18.941 19.2864L18.2457 20.5578C18.1725 20.6916 18.0646 20.8033 17.9334 20.8811C17.8022 20.9589 17.6525 20.9999 17.5 20.9999C17.3474 20.9999 17.1977 20.9589 17.0665 20.8811C16.9353 20.8033 16.8274 20.6916 16.7542 20.5578L16.059 19.2864C15.9792 19.1406 15.8593 19.0207 15.7135 18.941L14.4421 18.2457C14.3083 18.1725 14.1966 18.0646 14.1188 17.9334C14.041 17.8022 14 17.6525 14 17.5C14 17.3474 14.041 17.1977 14.1188 17.0665C14.1966 16.9353 14.3083 16.8274 14.4421 16.7542L15.7135 16.059C15.8593 15.9792 15.9792 15.8593 16.059 15.7135L16.7542 14.4421C16.8274 14.3083 16.9353 14.1966 17.0665 14.1188C17.1977 14.041 17.3474 14 17.5 14C17.6525 14 17.8022 14.041 17.9334 14.1188C18.0646 14.1966 18.1725 14.3083 18.2457 14.4421L18.941 15.7135C19.0207 15.8593 19.1406 15.9792 19.2864 16.059L20.5578 16.7542Z",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeymomentsIcon);
export default __webpack_public_path__ + "static/media/keymoments-icon.3b4718c7929b3060a8884d7cb252e802.svg";
export { ForwardRef as ReactComponent };